import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0eb932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = {
  class: "data-column-container",
  id: "player-list"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Name"),
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Rank")
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "data-column active-players-list"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"margin-left":"10px","margin-right":"12px"}
}, null, -1))
const _hoisted_6 = {
  id: "guest-name",
  class: "active-name"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me" }, "(me)", -1))
const _hoisted_8 = { class: "rank" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "name active-players" }
const _hoisted_11 = {
  class: "active-name",
  style: {"margin-left":"5px"}
}
const _hoisted_12 = { class: "rank" }
const _hoisted_13 = { class: "messaging-container" }
const _hoisted_14 = {
  id: "chat-messages",
  class: "messages"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.playerList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerList, (roomPlayer) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.player.playerId === roomPlayer.playerId)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: roomPlayer.playerId,
                      class: _normalizeClass(roomPlayer.guest ? 'row guest' : 'row')
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(roomPlayer.guest ? 'name active-players guest' : 'name active-players')
                      }, [
                        _hoisted_5,
                        _createElementVNode("span", _hoisted_6, [
                          _createTextVNode(_toDisplayString(roomPlayer.displayName) + " ", 1),
                          _hoisted_7
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getPlayerRank(roomPlayer)), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerList, (roomPlayer) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.player.playerId !== roomPlayer.playerId)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: roomPlayer.playerId,
                      class: "row other-players",
                      title: "Invite to play",
                      onClick: ($event: any) => (_ctx.onInvitePlayer(roomPlayer))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_fa_icon, {
                          icon: "gamepad",
                          color: "white",
                          class: "game-pad",
                          style: {"font-size":"20px","margin-top":"-1px"}
                        }),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(roomPlayer.displayName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getPlayerRank(roomPlayer)), 1)
                    ], 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatMessages, (chatMessage, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "message"
          }, [
            (chatMessage.playerId !== 'ALL')
              ? (_openBlock(), _createElementBlock("strong", _hoisted_15, _toDisplayString(chatMessage.playerId) + " : ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
              innerHTML: chatMessage.message
            }, null, 8, _hoisted_16)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "input-container",
        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
          type: "text",
          placeholder: "please type your message here...",
          class: "message-input"
        }, null, 512), [
          [_vModelText, _ctx.message]
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
          title: "Send message"
        }, [
          _createVNode(_component_fa_icon, {
            icon: "paper-plane",
            color: "#fff"
          })
        ])
      ], 32)
    ])
  ]))
}